import { computed, inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { STORAGE_SERVICE_TOKEN } from '@/core/util/storage.token';
import { STORAGE_KEYS } from '@/share/constant/storage_token.key';

/**
 * SRP: owns reactive user/session state only.
 * No HTTP calls, no menu logic — those live in AuthHttpService.
 */
@Injectable({ providedIn: 'root' })
export class SessionStateService {
    private readonly storage = inject(STORAGE_SERVICE_TOKEN);
    private readonly router = inject(Router);

    private readonly _user = signal<any>(this.storage.get(STORAGE_KEYS.USER));
    readonly user = this._user.asReadonly();
    readonly isLoggedIn = computed(() => !!this._user());

    setLoginUser(data: any): void {
        this.storage.set(STORAGE_KEYS.USER, data);
        this._user.set(data);
    }

    logout(): void {
        this.storage.clearAll();
        this._user.set(null);
        setTimeout(() => {
            this.router.navigate(['/auth/login']).then();
        })
    }

    setMenuItem(data: any[]): void {
        const flat = (items: any[]): string[] => (!items ? [] : items.flatMap((i: any) => [i.routing, ...flat(i.items)]));
        const labels = data.flatMap((i) => [i.routing, ...flat(i.items)]);
        labels.push('/dashboard', '/login', '/application-setting/ad-user');
        this.storage.set(STORAGE_KEYS.MENU_ITEM, labels);
    }

    getMenuItem(): any[] {
        return this.storage.get(STORAGE_KEYS.MENU_ITEM) || [];
    }
}
